export interface CooldownConfig {
  [key: string]: {
    duration: number; // Duration in milliseconds
    label: string;
  };
}

export const COOLDOWN_CONFIG: CooldownConfig = {
  title: {
    duration: 30000, // 30 seconds
    label: '30s'
  },
  description: {
    duration: 60000, // 1 minute
    label: '1m'
  },
  image: {
    duration: 120000, // 2 minutes
    label: '2m'
  },
  texture: {
    duration: 30000,
    label: '30s'
  },
  layout: {
    duration: 30000,
    label: '30s'
  },
  filters: {
    duration: 30000,
    label: '30s'
  },
  colors: {
    duration: 30000,
    label: '30s'
  },
  elements: {
    duration: 30000,
    label: '30s'
  },
  layers: {
    duration: 30000,
    label: '30s'
  },
  format: {
    duration: 30000,
    label: '30s'
  }
}; 